import axios from 'axiosConfig';

export const getAllLoanFund = (status) => {
    const data = status ? { status } : {};
    return axios.post("/api/codes/loanfund", data);
};
export const addNewLoanFund = (newFund) => axios.post("/api/codes/addloanfund", newFund, {});

export const updateLoanFund = (updatedFund) => axios.post("/api/codes/editloanfund", updatedFund, {});

export const deleteLoanFund = (deleteFund) => axios.post("/api/codes/deleteloanfund", deleteFund, {});

export const reactivateLoanFund = (reactivateFund) => axios.post("/api/codes/reactivateloanfund", reactivateFund, {});